module.exports = __webpack_public_path__ + "img/bg-banner-people-xl.44aedf81.png";